import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function CroCta() {
    return (
        <section className="cro-final-cta">
            <Container>
                <div className="cro-reveal">
                    <h2>
                        Want to improve your store{"'"}s<br />conversion rate?
                    </h2>
                    <p className="cta-sub">
                        Let us start with a free CRO audit — no commitment, just data-driven insights you can act on immediately.
                    </p>
                    <Link to="/book-audit" className="cro-btn-primary">
                        Get Your Free CRO Audit <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{verticalAlign: 'middle'}}><path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    </Link>
                </div>
            </Container>
        </section>
    );
}

